module.exports = __webpack_public_path__ + "static/media/about_us_header.15778439.svg";